// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__EidnN","search":"Settings_search__2mzcM","filter":"Settings_filter__1ynwz"};